import React from "react";
import ReactSelect, { Props as ReactSelectProps } from "react-select";
import colors from "../../../styles/colors";

const FlexSelect = (props: ReactSelectProps) => {
  return (
    <ReactSelect
      // components={{ MultiValueContainer }}
      {...props}
      styles={{ ...styles, ...props.styles }}
    />
  );
};

const styles = {
  multiValue: (base, state) => {
    return {
      ...base,
      // border: `2px dotted ${'red'}`,
      background: `${colors.trelloLabelColors[state.data.color] ?? "grey"}`,
      color: `${colors.generalColors.white}`,
      maxWidth: "160px",
      height: 26,
    };
  },
  multiValueLabel: (base) => ({
    ...base,
    // backgroundColor: colourOptions[2].color,
    color: `${colors.generalColors.white}`,
  }),
  // option: (base, state) => ({
  // 	...base,
  // 	background: `${colors.trelloLabelColors[state.data.color] ?? 'grey'}`,
  // 	color: `${colors.generalColors.white}`,
  // 	height: '36px',
  // 	textOverflow: 'ellipsis',
  //   overflow: 'hidden',
  // 	whiteSpace: 'nowrap',
  // 	textAlign: 'start',
  //   cursor: 'pointer',
  // }),
  menu: (base, state) => ({
    ...base,
    maxHeight: "200px",
    // maxWidth: '400px',
    minWidth: "200px",
    position: "absolute",
    top: "auto",
    // background: 'red',
    width: "100%",
    marginTop: 0,
  }),
  menuList: (base, state) => ({
    ...base,
    maxHeight: "inherit",
    textAlign: "left",
  }),
  control: (base, state) => ({
    ...base,
    borderWidth: "0 0 1px 0",
    boxShadow: "none",
    minWidth: 200,
    borderRadius: 0,
  }),
  input: (base, state) => ({
    ...base,
    height: 26,
  }),
  container: (base, state) => ({
    ...base,
    width: "100%",
  }),
};

export default FlexSelect;
